<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'stepper',
        props: {
            step: Number,
        },
    }
</script>


// WEBPACK FOOTER //
// Stepper.vue?cb574e6a